/* eslint-disable no-redeclare */
import { Plugin } from '@nuxt/types';
import { getBaseDomain } from '@root/common/utils/url';
import { Subscription } from '@paywall/types';
import { generateCustomerHash } from '@root/modules/customer/utils/generateCustomerHash';

interface cpUserPackage extends Window {
  cp_user_package_counter: number;
}

declare let window: cpUserPackage;
const addDays = (date: Date, days: number) => {
  const copy = new Date(Number(date));
  copy.setDate(date.getDate() + days);
  return copy;
};

const cookieName = 'cp_user_package';
const timeCookieName = 'cp_user_package_t';
// How often to refresh cookie value, in hours
const refreshInterval = 4;
const domain = getBaseDomain() || '';
const expires = addDays(new Date(), 90);
const path = '/';

// Set cp_user_package to differentiate user content in old portal and for cXense statistics
// TODO: Investigate do we need it after all channels will be moved to portal-root platform?
const cpUserPackage: Plugin = async (ctx) => {
  const { app } = ctx;
  const cookieAge = parseInt(app.$cookies.get(timeCookieName), 10);

  const setNewCookie = (subscription: Subscription | null) => {
    if (!subscription) {
      app.$cookies.remove(cookieName, { expires, domain, path });
    }
    if (subscription?.orders && subscription?.orders.length > 0) {
      const packages = subscription.orders.map((order) => order.product_code).sort();
      const hash = generateCustomerHash(packages.join(','));

      if (hash) {
        app.$cookies.set(cookieName, hash, { expires, domain, path });
      } else {
        app.$cookies.remove(cookieName, { expires, domain, path });
      }
    }
    app.$cookies.set(timeCookieName, new Date().getTime(), { expires, domain, path });
  };

  window.cp_user_package_counter = window.cp_user_package_counter || 0;
  const { subscription } = app.$instanceConnector('paywall').state;

  if (!cookieAge || cookieAge + refreshInterval * 60 * 60 * 1000 < new Date().getTime()) {
    setNewCookie(subscription);
  }

  app.$instanceConnector('customer').listen('token', () => {
    setTimeout(() => {
      const { subscription } = app.$instanceConnector('paywall').state;
      setNewCookie(subscription);
    }, 1000);
  });
};

export default cpUserPackage;
